import apiClient from '@/services/apiClient';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// ---------------- Admin: DC Invoice Google-Drive Sync ----------------
export const getDcInvoiceStatus = () =>
  apiClient.get('/dc-invoices/status').then((r) => r.data);

export const setDcInvoiceFolder = (folder) =>
  apiClient.put('/dc-invoices/drive-folder', { folder }).then((r) => r.data);

export const triggerDcInvoiceSync = () =>
  apiClient.post('/dc-invoices/sync').then((r) => r.data);

export const uploadBulkDcInvoices = (file) => {
  const form = new FormData();
  form.append('file', file);
  return apiClient
    .post('/dc-invoices/upload-bulk', form, { headers: { 'Content-Type': undefined } })
    .then((r) => r.data);
};

// ---------------- Admin: Transporter Portal Links ----------------
export const listPortalTransporters = () =>
  apiClient.get('/transporter-portal/admin/transporters').then((r) => r.data);

export const listPortalLinks = () =>
  apiClient.get('/transporter-portal/admin/links').then((r) => r.data);

export const createPortalLink = (transport_name) =>
  apiClient.post('/transporter-portal/admin/links', { transport_name }).then((r) => r.data);

export const regeneratePortalLink = (link_id) =>
  apiClient.post(`/transporter-portal/admin/links/${link_id}/regenerate`).then((r) => r.data);

export const togglePortalLink = (link_id, active) =>
  apiClient.post(`/transporter-portal/admin/links/${link_id}/toggle`, { active }).then((r) => r.data);

export const deletePortalLink = (link_id) =>
  apiClient.delete(`/transporter-portal/admin/links/${link_id}`).then((r) => r.data);

// ---------------- Public portal (passcode) ----------------
export const verifyPortal = (token, passcode) =>
  apiClient.post(`/transporter-portal/${token}/verify`, { passcode }).then((r) => r.data);

export const getPortalConsignments = (token, body) =>
  apiClient.post(`/transporter-portal/${token}/consignments`, body).then((r) => r.data);

export const getPortalPendingConsignments = (token, body) =>
  apiClient.post(`/transporter-portal/${token}/pending-consignments`, body).then((r) => r.data);

export const buildInvoiceUrl = (token, dcNumber, passcode) =>
  `${BACKEND_URL}/api/transporter-portal/${token}/invoice/${encodeURIComponent(dcNumber)}?passcode=${encodeURIComponent(passcode)}`;
